import React from "react";

import { useIsEnabled } from "./_enabler";

const LazyDragAndDrop = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { DragDropContext } = await import("react-beautiful-dnd");

	return { default: DragDropContext };
});

export type DragAndDropProps = React.ComponentProps<typeof LazyDragAndDrop>;

export const DragAndDrop = React.forwardRef<React.ComponentRef<typeof LazyDragAndDrop>, DragAndDropProps>(
	({ children, ...props }, ref) => {
		const isEnabled = useIsEnabled();

		if (!isEnabled) {
			return <>{children}</>;
		}

		return (
			<React.Suspense fallback={children}>
				<LazyDragAndDrop ref={ref} {...props}>
					{children}
				</LazyDragAndDrop>
			</React.Suspense>
		);
	},
);
